import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=497362fe&scoped=true&lang=pug&"
import script from "./MultiSelect.vue?vue&type=script&lang=ts&"
export * from "./MultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=497362fe&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497362fe",
  null
  
)

export default component.exports